<template>
  <div class="article-content">
    <div class="container">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleContent",
}
</script>

<style scoped>
.article-content {
  background-color: white;
  font-weight: 400;
  color: #111C24;
}
@media(min-width: 1540px) {
  .article-content {
    position: relative;
    display: block;
  }
  .container {
    padding: 0 20px 0 400px;
    width: 100%;
    max-width: 1320px;
    margin: 0 auto;
    min-height: 1200px;
  }
}
@media(max-width: 1539px) {
  .article-content {
    width: 900px;
    max-width: calc(100% - 540px);
    margin-left: 480px;
  }
}
@media(max-width: 1199px) {
  .article-content {
    max-width: calc(100% - 480px);
    margin-left: 420px;
  }
}
@media(min-width: 768px) and (max-width: 999px), (min-width: 1200px) {
  .article-content:deep(.row) {
    display: flex;
    margin: 0 -18px;
  }
  .article-content:deep(.col) {
    padding: 0 18px;
  }
  .article-content:deep(.col:first-child) {
    min-width: 33.333%;
    flex: 1 1 33.333%;
  }
  .article-content:deep(.col .image-box) {
    margin-top: 0.3em;
  }
  .article-content:deep(.col h3:first-child) {
    margin-top: 1em;
  }
}
.article-content:deep(p) {
  margin: 0 0 1.5em;
}
.article-content:deep(h3) {
  margin-top: 2.5em;
  margin-left: -0.01em;
  font-size: 22px;
  color: #102D61;
  font-weight: 500;
}
.article-content:deep(.image-box) {
  margin: calc(4% + 20px) 0;
}
.article-content:deep(img) {
  position: relative;
  display: block;
  max-width: 100%;
  height: auto;
}
.article-content:deep(.image-box h3) {
  margin-bottom: 0;
}
.article-content:deep(.image-box p) {
  font-weight: 700;
  color: #102D61;
  margin-top: 3px;
}
@media(max-width: 999px) {
  .article-content {
    padding: 0;
    max-width: none;
    width: auto;
    margin-left: 0;
    margin-right: 0;
  }
  .container {
    padding: 0 34px 20px;
  }
}
@media(max-width: 767px) {
  .container {
    padding: 20px;
    font-weight: 400;
    font-size: 15px;
    line-height: 1.6;
  }
  .article-content:deep(h3) {
    font-size: 18px;
  }

}
@media(max-width: 767px), (min-width: 1000px) and (max-width: 1199px) {
  .article-content:deep(.col figure) {
    display: flex;
  }
  .article-content:deep(.col figure img) {
    width: 50%;
    margin-right: 14px;
    height: intrinsic;
    flex: 1 1 50%;
  }
  .article-content:deep(.col figcaption) {
    border-top: 2px solid #9a989c;
    border-bottom: 2px solid #9a989c;
    padding: 10px 0;
    margin: 0;
  }
}
</style>